export default __webpack_public_path__ + "1b9309274c1bf269bdeb8e7d6aa9da18.svg";